import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { BUTTON_TYPE, ButtonComponent } from './ButtonComponent';
import { IModalWindow, ModalWindow } from './modal/ModalWindow';

interface Props {
	isEditMode: boolean;
	setIsEditMode: (value:boolean) => void;
	onSaveClick: () => void;
	onCancelClick: () => void;
	loading?: boolean;
}

export const SectionControlButtons: FC<Props> = (props) => {
	const { isEditMode, setIsEditMode, onSaveClick, onCancelClick, loading } = props;
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	return (
		<>
			{
				isEditMode
					? (
						<div className="d-flex align-items-center">
							<ButtonComponent
								buttonName="Cancel"
								additionalClass="btn-sm"
								buttonType={BUTTON_TYPE.CANCELLED}
								onButtonClick={onCancelClick}
								isDisabled={loading}
							/>
							<ButtonComponent
								buttonName="Save"
								additionalClass="btn-sm ms-10 w-75px"
								onButtonClick={():void => onSaveClick()}
								isDisabled={loading}
								loading={loading}
							/>
						</div>
					)
					: (
						<div
							className="text-danger d-flex align-items-center cursor-pointer"
							onClick={(): void => setIsEditMode(!isEditMode)}
						>
							<FontAwesomeIcon icon={faPenToSquare}/>
							<div className="ms-2 fs-6 fw-bolder">Edit</div>
						</div>
					)
			}
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};
